import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { NavLink } from "react-router-dom";
import CreditTab from "../CreditTab";
import { CommonPhoneInputFields } from "../../../util/CommonMasking";
import * as services from "../../../store/service";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import BusinessCreditProfileReview from "./BusinessCreditProfileReview";
import { stateList } from "../../../util/CommonLists";

const BusinessCreditProfileForm = (props: any) => {
    const dispatch = useDispatch();
    const query = new URLSearchParams(props.location.search);
    const [selectedTab, setSelectedTab] = useState("0");
    const [displayMainForm, setDisplayMainForm] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const [contactInfo, setContactInfo] = useState({
        BusinessName: "",
        Street: "",
        City: "",
        State: "",
        PostalCode: "",
        Phone: "",
        Email: "",
        FirstName: "",
        LastName: "",
        Website: "",
        CharterfileNumber: "",
        DUNSNumber: "",
        EIN: "",
        CreditProvider: "",

        StateList: [],
    });

    const submitCreditProfileForm = (data: any) => {
        setDisplayMainForm(false);
    };

    const { register, handleSubmit, errors, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const showMainForm = (flag: boolean) => {
        setDisplayMainForm(flag);
    };

    useEffect(() => {
        const tmpselectedTab = query.get("selectedTab");
        if (tmpselectedTab != null) {
            setSelectedTab(tmpselectedTab);
        }
        setIsLoading(true);
        services.getSmbContactInfo().then((data: any) => {
            setIsLoading(false);
            setContactInfo({
                ...contactInfo,
                BusinessName: data?.businessName,
                Street: data?.address1,
                City: data?.city,
                State: data?.state,
                PostalCode: data?.zipCode,
                Phone: data?.phone,
                Email: data?.email,
                FirstName: data?.firstName,
                LastName: data?.lastName,
                EIN: data?.ein,
                CreditProvider: creditProvider,
            });
        });
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Credit
                    </h1>
                </div>
                <div className="col-xs flex-grow-null">
                    {selectedTab === "0" && (
                        <button
                            type="button"
                            className="btn-default btn-primary-outline btn-no-border btn-no-padding btn-icon-only"
                            onClick={() => props.history.push("/dashboard")}
                        >
                            <span className="btn-icon">
                                <em className="las la-times"></em>
                            </span>
                            <span className="btn-text">Cancel</span>
                        </button>
                    )}
                </div>
            </div>

            {selectedTab !== "0" && <CreditTab selectedTab={selectedTab} />}

            <div className="row" id="content">
                <div className="col-xs-12">
                    {displayMainForm ? (
                        <div className="box offset-padding">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon" aria-hidden="true">
                                        <em className="las la-plus"></em>
                                    </div>
                                    <div className="box-title-text has-actions">
                                        <h2 className="box-title">Add My Business Name and Address</h2>
                                    </div>
                                </div>
                            </div>
                            <div className={`box-content ${isLoading && "loading"}`}>
                                <form id="form-add-business-credit-profile" onSubmit={handleSubmit(submitCreditProfileForm)}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-name-label">
                                                Business Name{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessName"] && "status-error"}`}>
                                            <input
                                                type="text"
                                                id="business-name-label"
                                                className="inputbox"
                                                name="businessName"
                                                defaultValue={contactInfo.BusinessName}
                                                ref={register({ required: true, pattern: PATTERNS.BUSINESSNAME.pattern })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        BusinessName: e.target.value,
                                                    })
                                                }
                                            />
                                            {errors["businessName"] && errors["businessName"].type === "required" && (
                                                <span className="form-error">Business Name is required.</span>
                                            )}
                                            {errors["businessName"] && errors["businessName"].type === "pattern" && (
                                                <span className="form-error"> {PATTERNS.BUSINESSNAME.message}</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-address-street-label">
                                                Business Address Street{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessStreet"] && "status-error"}`}>
                                            <input
                                                type="text"
                                                id="business-address-street-label"
                                                className="inputbox"
                                                name="businessStreet"
                                                defaultValue={contactInfo.Street}
                                                ref={register({ required: true, pattern: PATTERNS.STREETADDRESS.pattern })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        Street: e.target.value,
                                                    })
                                                }
                                            />
                                            {errors["businessStreet"] && errors["businessStreet"].type === "required" && (
                                                <span className="form-error">Address Street Name & Number is required</span>
                                            )}
                                            {errors["businessStreet"] && errors["businessStreet"].type === "pattern" && (
                                                <span className="form-error">
                                                    Invalid format. Address Street Number and Name can only include letters, numbers, and the special characters:
                                                    #-/,.
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-address-city-label">
                                                Business Address City{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessCity"] && "status-error"}`}>
                                            <input
                                                type="text"
                                                id="business-address-city-label"
                                                className="inputbox"
                                                name="businessCity"
                                                defaultValue={contactInfo.City}
                                                ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        City: e.target.value,
                                                    })
                                                }
                                            />
                                            {errors["businessCity"] && errors["businessCity"].type === "required" && (
                                                <span className="form-error">City is required.</span>
                                            )}
                                            {errors["businessCity"] && errors["businessCity"].type === "pattern" && (
                                                <span className="form-error">
                                                    Invalid Format. City can only include letters, spaces, and the special character: .
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-row inline row ">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-address-state-label">
                                                State{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessState"] && "status-error"}`}>
                                            <select
                                                id="business-address-state-label"
                                                className="inputbox"
                                                name="businessState"
                                                value={contactInfo.State}
                                                ref={register({ required: true, pattern: /^[a-zA-Z.\s]+$/ })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        State: e.target.value,
                                                    })
                                                }
                                            >
                                                {stateList.map((state: any, index: number) => (
                                                    <option key={`state-${index}`} value={state.value}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors["businessState"] &&
                                                (errors["businessState"].type === "required" || errors["businessState"].type === "pattern") && (
                                                    <span className="form-error">State is required.</span>
                                                )}
                                        </div>
                                    </div>

                                    <div className="form-row inline row ">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-address-zip-code">
                                                Zip Code{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessZip"] && "status-error"}`}>
                                            <input
                                                type="text"
                                                id="business-address-zip-code"
                                                className="inputbox"
                                                name="businessZip"
                                                defaultValue={contactInfo.PostalCode}
                                                ref={register({ required: true, pattern: PATTERNS.ZIPCODE.pattern })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        PostalCode: e.target.value,
                                                    })
                                                }
                                            />
                                            {errors["businessZip"] && errors["businessZip"].type === "required" && (
                                                <span className="form-error">Zip code is required</span>
                                            )}
                                            {errors["businessZip"] && errors["businessZip"].type === "pattern" && (
                                                <span className="form-error">
                                                    Invalid format. Zip code must be entered in either of the two formats: 01234 OR 01234-5678
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="margin-top-xl"></div>

                                    <h2 className="content-sub-title">Add My Contact and Business Information</h2>

                                    <div className="margin-top-s"></div>

                                    <fieldset className="form-row inline no-margin">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label-business-phone-number">
                                                    Business Phone Number{" "}</label>
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </legend>
                                            </div>

                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="row ">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12  col-no-gutter">
                                                                <label htmlFor="label-business-phone-number">Number </label>
                                                            </div>
                                                            <div
                                                                className={`form-input col-xs-12 col-sm-12 col-no-gutter ${
                                                                    errors["phoneNumber"] && "status-error"
                                                                }`}
                                                            >
                                                                <CommonPhoneInputFields
                                                                    NAME={`phoneNumber`}
                                                                    REF={register({
                                                                        required: true,
                                                                        maxLength: 14,
                                                                        minLength: 14,
                                                                        pattern: PATTERNS.PHONE.pattern,
                                                                    })}
                                                                    ID={"label-business-phone-number"}
                                                                    DefaultVal={contactInfo.Phone}
                                                                    OnChange={(e: any) =>
                                                                        setContactInfo({
                                                                            ...contactInfo,
                                                                            Phone: e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "required" && (
                                                                    <span className="form-error">Phone Number is required</span>
                                                                )}
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "pattern" && (
                                                                    <span className="form-error">
                                                                        Invalid format. Phone Number can only include numbers and must be 10 digits in length.
                                                                    </span>
                                                                )}
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "minLength" && (
                                                                    <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                                                )}
                                                                {errors["phoneNumber"] && errors["phoneNumber"].type === "maxLength" && (
                                                                    <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-email-address-label">
                                                Email Address{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessEmail"] && "status-error"}`}>
                                            <input
                                                type="text"
                                                id="business-email-address-label"
                                                className="inputbox"
                                                name="businessEmail"
                                                defaultValue={contactInfo.Email}
                                                ref={register({ required: true, pattern: PATTERNS.EMAIL.pattern })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        Email: e.target.value,
                                                    })
                                                }
                                            />
                                            {errors["businessEmail"] && errors["businessEmail"].type === "pattern" && (
                                                <span className="form-error">Please enter your valid email address.</span>
                                            )}
                                            {errors["businessEmail"] && errors["businessEmail"].type === "required" && (
                                                <span className="form-error">Business email is required.</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="business-website-label">Business Website</label>
                                        </div>
                                        <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessWebsite"] && "status-error"}`}>
                                            <input
                                                type="text"
                                                id="business-website-label"
                                                className="inputbox"
                                                name="businessWebsite"
                                                defaultValue={contactInfo.Website}
                                                ref={register({ pattern: PATTERNS.WEBSITE.pattern })}
                                                onChange={(e) =>
                                                    setContactInfo({
                                                        ...contactInfo,
                                                        Website: e.target.value,
                                                    })
                                                }
                                            />
                                            {errors["businessWebsite"] && errors["businessWebsite"].type === "pattern" && (
                                                <span className="form-error">Please provide a valid website</span>
                                            )}
                                        </div>
                                    </div>

                                    {creditProvider != null && creditProvider === "DUNBRADSTREET" && (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="business-duns-number-label">
                                                    D&B Number(D-U-N-S)
                                                    <span className="tooltip-container" tabIndex={0}>
                                                        <em className="las la-info-circle" aria-hidden="true"></em>
                                                        <span className="tooltip-text">
                                                            Your D-U-N-S Number is D&B&apos;s identification number for your company. The number provides unique
                                                            identification of your organization, in accordance with the Data Universal Numbering System (D-U-N-S).
                                                        </span>
                                                    </span>
                                                </label>
                                            </div>
                                            <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["dunsNumber"] && "status-error"}`}>
                                                <input
                                                    type="text"
                                                    id="business-duns-number-label"
                                                    className="inputbox"
                                                    name="dunsNumber"
                                                    ref={register({
                                                        maxLength: 9,
                                                        minLength: 0,
                                                        pattern: PATTERNS.DUNSNUMBER.pattern,
                                                    })}
                                                    defaultValue={contactInfo.DUNSNumber}
                                                    onChange={(e) =>
                                                        setContactInfo({
                                                            ...contactInfo,
                                                            DUNSNumber: e.target.value,
                                                        })
                                                    }
                                                />
                                                {errors["dunsNumber"] && errors["dunsNumber"].type === "pattern" && (
                                                    <span className="form-error">
                                                        Invalid format. D&B Number can only include numbers and must be 9 digits in length.
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {creditProvider != null && creditProvider === "CREDITSAFE" && (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="business-charterfile-number-label">
                                                    Charterfile Number
                                                    <span className="tooltip-container" tabIndex={0}>
                                                        <em className="las la-info-circle" aria-hidden="true"></em>
                                                        <span className="tooltip-text">
                                                            The Charter Number, also known as the File Number, is a unique, alpha-numeric identifier assigned to
                                                            each entity upon filing with the Secretary of State.
                                                        </span>
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <input
                                                    type="text"
                                                    id="business-charterfile-number-label"
                                                    className="inputbox"
                                                    name="charterfileNumber"
                                                    defaultValue={contactInfo.CharterfileNumber}
                                                    onChange={(e) =>
                                                        setContactInfo({
                                                            ...contactInfo,
                                                            CharterfileNumber: e.target.value,
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {creditProvider != null && creditProvider === "CREDITSAFE" && (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="business-ein-label">
                                                    Company EIN
                                                    <span className="tooltip-container" tabIndex={0}>
                                                        <em className="las la-info-circle" aria-hidden="true"></em>
                                                        <span className="tooltip-text">
                                                            The EIN (Employer Identification Number) is a unique numerical identifier used to identify businesses,
                                                            partnerships, or other entities. To locate your EIN, contact your local IRS office.
                                                        </span>
                                                    </span>
                                                </label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <input
                                                    type="text"
                                                    id="business-ein-label"
                                                    className="inputbox"
                                                    name="businessEin"
                                                    defaultValue={contactInfo.EIN}
                                                    ref={register({ pattern: PATTERNS.EIN.pattern })}
                                                    onChange={(e) =>
                                                        setContactInfo({
                                                            ...contactInfo,
                                                            EIN: e.target.value,
                                                        })
                                                    }
                                                />
                                                {errors["businessEin"] && errors["businessEin"].type === "pattern" && (
                                                    <span className="form-error">{PATTERNS.EIN.message}</span>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="margin-top-xl"></div>

                                    <div className="row between-xs">
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            {selectedTab === "0" ? (
                                                <NavLink to="/bcredit/search" className="btn-default btn-primary-outline">
                                                    <span className="btn-text">Back</span>
                                                </NavLink>
                                            ) : (
                                                <NavLink to={"/bcredit/search?selectedTab=" + selectedTab} className="btn-default btn-primary-outline">
                                                    <span className="btn-text">Back</span>
                                                </NavLink>
                                            )}
                                        </div>
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            <button type="submit" className="btn-default btn-primary btn-min-width">
                                                <span className="btn-text">Continue</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    ) : (
                        <BusinessCreditProfileReview
                            backToMainForm={() => showMainForm}
                            BusinessName={contactInfo.BusinessName}
                            Street={contactInfo.Street}
                            City={contactInfo.City}
                            State={contactInfo.State}
                            PostalCode={contactInfo.PostalCode}
                            Phone={contactInfo.Phone}
                            Email={contactInfo.Email}
                            Website={contactInfo.Website}
                            CharterfileNumber={contactInfo.CharterfileNumber}
                            DUNSNumber={contactInfo.DUNSNumber}
                            EIN={contactInfo.EIN}
                            FirstName={contactInfo.FirstName}
                            LastName={contactInfo.LastName}
                            CreditProvider={contactInfo.CreditProvider}
                        />
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default BusinessCreditProfileForm;
